/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动 ID
   */
  event_id: string;
}
export interface DashboardEventGetProgressOfModuleRes {
  msg: string;
  nonce: string;
  code: string;
  data: Data;
}
export interface Data {
  /**
   * 是否编辑日程，若不是必填项则是false
   */
  b_edit_scheduler: boolean;
  /**
   * 是否编辑门票，若不是必填项则是false
   */
  b_edit_ticket: boolean;
  /**
   * 是否编辑人员，若不是必填项则是false
   */
  b_edit_guest: boolean;
  /**
   * 是否编辑报名页配置，若不是必填项则是false
   */
  b_edit_register_config: boolean;
  /**
   * 是否编辑基础信息	，若不是必填项则是false
   */
  b_edit_basic: boolean;
  /**
   * 是否预览与发布	，若不是必填项则是false
   */
  b_edit_publish: boolean;
}

const DashboardEventGetProgressOfModule = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventGetProgressOfModuleRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/get-progress-of-module',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventGetProgressOfModule;
